import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { KeyboardActions } from './keyboard.actions';

/**
 * Keyboard component.
 */
@Component({
  selector: 'app-keyboard',
  template: ``,
  standalone: true
})
export class KeyboardComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly store = inject(Store);

  keyboard = {
    show: false
  };

  destroyed = new Subject<boolean>();

  /**
   * On Init.
   */
  ngOnInit(): void {
    this.subscribe();
  }

  /**
   * OnDestroy.
   */
  ngOnDestroy(): void {
    this.unsubscribe();
  }

  /**
   * Subscribe.
   */
  subscribe(): void {
    if (Capacitor.isNativePlatform()) {
      Keyboard.addListener('keyboardWillShow', (info) => {
        this.store.dispatch(
          KeyboardActions.willShow({ height: info.keyboardHeight })
        );
      });
      Keyboard.addListener('keyboardDidShow', () => {
        this.keyboard.show = true;
        this.store.dispatch(KeyboardActions.didShow());
      });
      Keyboard.addListener('keyboardDidHide', () => {
        this.keyboard.show = false;
        this.store.dispatch(KeyboardActions.didHide());
      });
    }
    this.hideKeyboardOnRouteChange();
  }

  /**
   * Unsubscribe.
   */
  unsubscribe(): void {
    if (Capacitor.isNativePlatform()) {
      Keyboard.removeAllListeners();
    }
    this.destroyed.next(true);
    this.destroyed.complete();
  }

  /**
   * Hide the keyboard when the route change.
   *
   * Reason: sometimes the keyboard still showing whenever user has submitted the form
   * We dont want that happen it will annoy users, so when the route changed we will
   * hide the keyboard.
   *
   * @returns {void}
   */
  hideKeyboardOnRouteChange(): void {
    this.router.events.pipe(takeUntil(this.destroyed)).subscribe({
      /**
       * On next.
       *
       * @param {Event} e Event.
       */
      next: (e) => {
        if (e instanceof NavigationEnd) {
          if (this.keyboard.show && Capacitor.isNativePlatform()) {
            Keyboard.hide();
          }
        }
      }
    });
  }
}
